// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `label[data-v-1c06d4ff]{padding-right:12px}div[data-v-1c06d4ff]{display:flex;align-items:center}`, "",{"version":3,"sources":["webpack://./src/components/SearchSettings.vue"],"names":[],"mappings":"AAEA,uBACC,kBAAA,CAGD,qBACC,YAAA,CACA,kBAAA","sourcesContent":["\n\nlabel {\n\tpadding-right: 12px;\n}\n\ndiv{\n\tdisplay: flex;\n\talign-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
